<animated-content *ngIf="!immediate; else static">
    <ng-container [ngTemplateOutlet]="static"></ng-container>
</animated-content>
<ng-template #static>
    <ul class="input-errors">
        <li *ngFor="let err of errors; trackBy: trackByFn" [attr.data-error-name]="err.name">{{ err.message }}</li>
    </ul>
</ng-template>
